import SubHeader from "../components/Subheader";
import DisplayRepertoire from "../features/DisplayRepertoire";

const RepertoirePage = () => {
  return (
    <>
      <SubHeader current="Repertoire Page" />
      <DisplayRepertoire />
    </>
  );
};

export default RepertoirePage;
